<template>
  <div class="footer mt-auto">
    <div class="container py-8 text-center"></div>
  </div>
</template>
